import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Key, Calendar, AlertTriangle, MapPin, RotateCcw, Plus } from 'lucide-react';
import { formatDate } from './utils';

export const RentalSection = ({ rentals, onAssign, onReturn }) => (
  <div className="space-y-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Key className="w-6 h-6 text-blue-500" />
        <h2 className="text-2xl font-heading font-bold">Équipements de Location</h2>
        <Badge variant="secondary" className="text-base px-4 py-1">
          {rentals.length} emprunt{rentals.length > 1 ? 's' : ''}
        </Badge>
      </div>
      <Button data-testid="add-rental-assignment-button" onClick={onAssign} variant="secondary" className="rounded-full">
        <Plus className="w-4 h-4 mr-2" /> Assigner Équipement Location
      </Button>
    </div>

    {rentals.length > 0 ? (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {rentals.map((rental) => (
          <Card key={rental.id} data-testid={`collab-rental-${rental.id}`} className="hover:shadow-lg transition-shadow duration-200 border-blue-200">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  {rental.equipment?.photo ? (
                    <img src={rental.equipment.photo} alt={rental.equipment.name} className="w-12 h-12 object-contain bg-muted rounded-lg" />
                  ) : (
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Key className="w-6 h-6 text-blue-500" />
                    </div>
                  )}
                  <div>
                    <CardTitle className="text-lg font-heading flex items-center gap-2">
                      {rental.equipment?.name}
                      <Badge variant="secondary">x{rental.quantity}</Badge>
                    </CardTitle>
                    <Badge variant="outline" className="mt-1 text-xs border-blue-300 text-blue-600">Location</Badge>
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="text-sm space-y-1">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Calendar className="w-4 h-4" /><span>Emprunté le: {formatDate(rental.borrowed_date)}</span>
                </div>
                {rental.expected_return_date && (
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <AlertTriangle className="w-4 h-4" /><span>Retour prévu: {formatDate(rental.expected_return_date)}</span>
                  </div>
                )}
                {rental.equipment?.storage_location && (
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <MapPin className="w-4 h-4" /><span>Retour à: {rental.equipment.storage_location}</span>
                  </div>
                )}
              </div>
              <Button data-testid={`return-collab-rental-${rental.id}`} onClick={() => onReturn(rental.id)} variant="outline" size="sm" className="w-full rounded-full">
                <RotateCcw className="w-4 h-4 mr-2" /> Retourner
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    ) : (
      <Card className="border-2 border-dashed border-blue-200">
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Key className="w-12 h-12 text-blue-300 mb-4" />
          <p className="text-muted-foreground">Aucun équipement de location emprunté</p>
        </CardContent>
      </Card>
    )}
  </div>
);
